import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children }) => (
  <div className="flex items-center gap-4 font-mono text-xs uppercase tracking-[0.3em] text-teal-300">
    <span className="text-amber-400">{index}</span>
    <span className="h-px w-10 bg-teal-400/40" />
    <span>{children}</span>
  </div>
);
